module.exports = __webpack_public_path__ + "img/FMCS1.e20fea1d.png";